import { render, staticRenderFns } from "./CouponSelect.vue?vue&type=template&id=67678118&scoped=true"
import script from "./CouponSelect.vue?vue&type=script&lang=js"
export * from "./CouponSelect.vue?vue&type=script&lang=js"
import style0 from "./CouponSelect.vue?vue&type=style&index=0&id=67678118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67678118",
  null
  
)

export default component.exports